import CookiesJS from 'cookies-js';

export function initManagerTasks($, apiClient) {
    $('form.manager-task-form .action__entity-save').on('click', async function () {
        try {
            const body = {
                userId: $('#userId').val(),
                notifyOnCreate: !!$('#notifyOnCreate').prop('checked'),
                notifyOnSuccess: !!$('#notifyOnSuccess').prop('checked'),
                notifyOnError: !!$('#notifyOnError').prop('checked'),
                assignTrainings: !!$('#assignTrainings').prop('checked'),
                assignPractices: !!$('#assignPractices').prop('checked'),
                assignRecommendations: !!$('#assignRecommendations').prop('checked'),
                assignProgramms: !!$('#assignProgramms').prop('checked'),
            };
            const result = await apiClient.create('/manager-tasks', body, CookiesJS.get('auth_token'));
            console.log(result);
            document.location.href=`/manager-tasks/edit/${result._id}`;
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
